// @ts-nocheck
import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

function initEightProductGrid() {
  const config = {
    dom: {
      section: '.eight-product-grid',
      productSwatchesSlider: '.eight-product-grid__product .product-unit__swatches.swatches-container.slider'
    }
  };

  const c = config;
  function init() {
    const $section = document.querySelector(c.dom.section);
    if (!$section) return;
    initializeColorSwatchesSlider();
  }

  function initializeColorSwatchesSlider() {
    document.querySelectorAll(c.dom.productSwatchesSlider).forEach(function(slider) {
      setTimeout(function() { calpak.checkSlider(slider); }, 10);
    });
  }

  document.addEventListener('calpak:ready', function() {
    init();
  });
}

export default initEightProductGrid;